import React from "react";
import Icon from "@ant-design/icons";


const AttendanceSuccessSvg = () => (
    <svg
        fill="currentColor"
        width="1em"
        height="1em"
        viewBox="0 0 64 64"
    >
        <path
            transform="translate(4.00037 9.33306)"
            fillRule="evenodd"
            d="M24.318834 45.171745C23.438835 45.171745 22.590836 44.823746 21.962835 44.197079L0.97750163 23.245079C-0.32383174 21.945078 -0.32649839 19.834412 0.97350162 18.531744C2.2735016 17.227745 4.3841681 17.226412 5.688168 18.527744L23.957502 36.767746L50.573502 1.3330781C51.678837 -0.1389219 53.769501 -0.4389219 55.24017 0.66907811C56.713501 1.7744114 57.010834 3.8650782 55.904167 5.3370781L26.984169 43.839745C26.404169 44.613079 25.517502 45.09441 24.556168 45.163746C24.476168 45.169079 24.397501 45.171745 24.318834 45.171745"
        />
    </svg>
);

const AttendanceSuccessIcon = ({ className }) => (
    <Icon component={ AttendanceSuccessSvg } className={ className } />
);

export default AttendanceSuccessIcon;
